import React from 'react';

import { Typography } from 'antd';

import './index.less';

const { Title } = Typography;

export default ({}) => {
    return (
        <div className="waste__to-consume">
          <Title level={2}>Resíduos a Consumir</Title>
        </div>
    );
}
